import React, { Component } from 'react';
import Authentication from '../authentication/Authentication';
import { connect } from 'react-redux';
import { loginRequest } from '../../../actions/authentication';
import * as path from '../../../route/PathConfig'

class Login extends Component {  
  handleLogin = (email, password) => {
    return this.props.loginRequest(email, password).then(
      () => {
          if(this.props.status === "SUCCESS") {
              // create session data
              let loginData = {
                  isLoggedIn: true,
                  email: email
              };

              document.cookie = 'key=' + btoa(JSON.stringify(loginData));

              // Materialize.toast('Welcome, ' + email + '!', 2000);
              this.props.history.push(path.DEFAULT);
              return true;
          } else {
              // let $toastContent = $('<span style="color: #FFB4BA">Incorrect username or password</span>');
              // Materialize.toast($toastContent, 2000);
              return false;
          }
        }
      );
    }
 
  render() {
    return (
      <Authentication mode={true} onLogin={this.handleLogin}/>
    );
  }
}
 
const mapStateToProps = (state) => {
    return {
        status: state.AuthManager.login.status
    };
};
 
const mapDispatchToProps = (dispatch) => {
    return {
        loginRequest: (email, password) => {
            return dispatch(loginRequest(email, password));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);